// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Track page views
export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track search events
export const trackSearch = (searchTerm: string) => {
  event({
    action: 'search',
    category: 'engagement',
    label: searchTerm,
  });
};

// Track button clicks
export const trackButtonClick = (buttonName: string) => {
  event({
    action: 'click',
    category: 'engagement',
    label: buttonName,
  });
};

// Track mood analysis
export const trackMoodAnalysis = () => {
  event({
    action: 'mood_analysis_requested',
    category: 'feature_usage',
    label: 'cosmic_insight',
  });
};

// Track question submission
export const trackQuestionSubmission = (question: string) => {
  event({
    action: 'question_submitted',
    category: 'feature_usage',
    label: 'user_question',
  });
};

// Track language change
export const trackLanguageChange = (language: string) => {
  event({
    action: 'language_changed',
    category: 'user_preference',
    label: language,
  });
}; 